import { type FC, type RefObject } from 'react';

import { DesktopFilterMenu } from '$/components/core/Collection/CollectionFilter/components/DesktopFilterMenu';
import { MobileFilterDrawer } from '$/components/core/Collection/CollectionFilter/components/MobileFilter/MobileFilterDrawer';
import { useIsMobile } from '$/hooks/useIsMobile';

interface Props {
  sectionRef: RefObject<HTMLDivElement | null>;
  hideAmounts?: boolean;
  amount?: number;
  allowedFilters?: string[];
}

export const CollectionFilter: FC<Props> = ({
  sectionRef,
  hideAmounts = false,
  amount,
  allowedFilters,
}) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <MobileFilterDrawer amount={amount} allowedFilters={allowedFilters} />
    );
  }

  return (
    <DesktopFilterMenu
      sectionRef={sectionRef}
      hideAmounts={hideAmounts}
      allowedFilters={allowedFilters}
    />
  );
};
